import React__default from 'react';
import classNames from 'classnames';
import Styles from './RouteState.module.scss.js';
import { ReactComponent as SvgPlusDark } from '../../icons/PlusDark.svg.js';
import { ReactComponent as SvgTickBlue } from '../../icons/tick_blue.svg.js';

const RouteState = ({ routeValue, isSelect, isSectionRoute, routeClass, onClickSelect, index }) => {
    return (React__default.createElement("span", { className: classNames(Styles.route, routeClass, isSelect && Styles.selected), onClick: () => index && onClickSelect(index), key: index },
        !isSectionRoute && React__default.createElement(React__default.Fragment, null, isSelect ? React__default.createElement(SvgTickBlue, null) : React__default.createElement(SvgPlusDark, null)),
        routeValue));
};

export { RouteState as default };
//# sourceMappingURL=RouteState.js.map
